import { Box, Icon, IconButton, IconNewIds as IconIds, LoaderNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import * as React from 'react'
import { FC, createRef, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import List from '../../comps/List'
import { ListData } from '../../comps/List/types'
import { ListItemType } from '../../comps/ListItem'
import { sideMenuBottomData } from '../../data/static/data'
import { loginStrings } from '../../data/static/strings'
import { Routes } from '../../nav/routes'
import styles from './styles'

const isBeneficiaryOnboardingEnabled = true
const mid = 'MID'

const getBeneficiaryMenu = () => {
  return isBeneficiaryOnboardingEnabled
    ? {
        id: '15',
        value: 'Payouts',
        iconId: 'TRANSACTIONS',
        hasSubMenu: true,
        path: Routes.PAYOUTS_BENEFICIARY,
        navigateTo: Routes.PAYOUTS_BENEFICIARY,
        subMenu: [
          // {
          //   id: '1',
          //   value: 'Payouts History',
          //   navigateTo: Routes.PAYOUTS_HISTORY,
          // },
          {
            id: '2',
            value: 'Beneficiary',
            navigateTo: Routes.PAYOUTS_BENEFICIARY,
          },
          // {
          //   id: '3',
          //   value: 'Payout Link',
          //   navigateTo: Routes.PAYOUTS_LINK,
          // },
        ],
      }
    : {}
}
interface NavBarProps {
  onPress: (item: ListData) => void
  disableBulkRefund?: boolean
  userPermissionsNotAllowed?: Array<String>
  permissionLoader: boolean
  isSuperMerchant?: boolean
  showPayouts?: boolean
}

export const defaultSuperMerchantSideMenuData = [
  {
    id: '1',
    value: 'Home',
    iconId: 'HOME',
    path: Routes.RECENTS,
    navigateTo: Routes.RECENTS,
  },
  {
    id: '2',
    value: 'Transactions',
    iconId: 'TRANSACTIONS',
    svgImageName: 'transactionsIcon',
    path: Routes.TRANSACTIONS,
    navigateTo: Routes.TRANSACTIONS,
  },
  {
    id: '3',
    value: 'Settlements',
    iconId: 'SETTLEMENTS',
    hasSubMenu: false, //Need to be true if any item menu has subMenu
    path: Routes.SETTLEMENTS,
    navigateTo: Routes.SETTLEMENTS,
  },
  // {
  //   id: '31',
  //   value: 'Settlements',
  //   navigateTo: Routes.SETTLEMENTS,
  //   parentId: '3', //and need to pass this to act as submenu of settlements
  // },
  // {
  //   id: '32',
  //   value: 'Settlements Reporting',
  //   navigateTo: Routes.SETTLEMENTS_REPORTING,
  //   parentId: '3', ///and need to pass this to act as submenu of settlements
  // },
  {
    id: '4',
    value: 'Refunds',
    iconId: 'REFUNDS',
    navigateTo: Routes.REFUNDS,
    path: 'refund-reports',
  },
  {
    id: 'DIVIDER',
    isDivider: true,
  },
  {
    id: '13',
    value: 'Downloads',
    iconId: 'DOWNLOAD',
    navigateTo: Routes.DOWNLOADS,
    path: Routes.DOWNLOADS,
  },
  {
    id: '10',
    value: 'Settings',
    iconId: 'SETTING',
    navigateTo: Routes.SETTINGS,
    path: Routes.SETTINGS,
  },
]

export const defaultSideMenuData = [
  {
    id: '1',
    value: 'Home',
    iconId: 'HOME',
    path: Routes.RECENTS,
    navigateTo: Routes.RECENTS,
  },
  {
    id: '2',
    value: 'Transactions',
    iconId: 'TRANSACTIONS',
    svgImageName: 'transactionsIcon',
    path: Routes.TRANSACTIONS,
    navigateTo: Routes.TRANSACTIONS,
  },
  {
    id: '3',
    value: 'Settlements',
    iconId: 'SETTLEMENTS',
    path: Routes.SETTLEMENTS,
    navigateTo: Routes.SETTLEMENTS,
  },
  {
    id: '4',
    value: 'Refunds',
    iconId: 'REFUNDS',
    path: 'refund-reports',
    navigateTo: Routes.REFUNDS,
  },
  {
    id: '17',
    value: 'PRODUCTS',
    isDivider: true,
  },
  {
    id: '7',
    value: 'Insights',
    iconId: 'INSIGHTS',
    path: Routes.INSIGHTS,
    navigateTo: Routes.INSIGHTS,
    showBetaTag: true,
  },
  {
    id: '9',
    value: 'Vault',
    iconId: 'VAULT',
    path: Routes.VAULT,
    navigateTo: Routes.VAULT,
  },
  {
    id: '5',
    value: 'Payment Links',
    iconId: 'PAYMENT_LINKS',
    path: 'payment-links',
    navigateTo: Routes.PAYMENT_LINKS,
  },
  {
    id: '6',
    value: 'Subscriptions',
    iconId: 'REFUNDS',
    path: Routes.SUBSCRIPTIONS,
    navigateTo: Routes.SUBSCRIPTIONS,
  },
  getBeneficiaryMenu(),
  {
    id: '11',
    value: 'Campaigns',
    iconId: 'SETTING',
    navigateTo: Routes.CAMPAIGNS,
    path: Routes.CAMPAIGNS,
  },
  {
    id: '12',
    value: 'UPI QR code',
    iconId: 'SCAN_QR',
    navigateTo: Routes.UPIQRCODE,
    path: Routes.UPIQRCODE,
  },
  {
    id: '18',
    isDivider: true,
  },
  {
    id: '13',
    value: 'Downloads',
    iconId: 'DOWNLOAD',
    navigateTo: Routes.DOWNLOADS,
    path: Routes.DOWNLOADS,
  },
  {
    id: '10',
    value: 'Settings',
    iconId: 'SETTING',
    navigateTo: Routes.SETTINGS,
    path: Routes.SETTINGS,
  },
  {
    id: '16',
    value: 'Help & Support',
    iconId: 'CHAT',
    navigateTo: Routes.HELP_AND_SUPPORT,
  },
]

export const sideMenuTidUserdata = [
  {
    id: '1',
    value: 'Home',
    iconId: IconIds.HOME,
    navigateTo: Routes.DEFAULT,
  },
  {
    id: '2',
    value: 'Transactions',
    iconId: IconIds.TRANSACTIONS,
    navigateTo: Routes.DEFAULT + Routes.TRANSACTIONS,
  },
  {
    id: '3',
    value: 'Settlements',
    iconId: IconIds.SETTLEMENTS,
    navigateTo: Routes.DEFAULT + Routes.SETTLEMENTS,
  },
  {
    id: '4',
    value: 'Refunds',
    iconId: IconIds.REFUNDS,
    navigateTo: Routes.DEFAULT + Routes.REFUNDS,
  },
  {
    id: '5',
    value: 'Payment Links',
    iconId: IconIds.PAYMENT_LINKS,
    navigateTo: Routes.DEFAULT + Routes.PAYMENT_LINKS,
  },
  {
    id: '5',
    value: 'Bulk Refund',
    iconId: IconIds.BULK_REFUND,
    navigateTo: Routes.DEFAULT + Routes.BULK_REFUND,
  },
  {
    id: '6',
    value: 'Subscriptions',
    iconId: IconIds.REFUNDS,
    navigateTo: Routes.DEFAULT + Routes.SUBSCRIPTIONS,
  },
  // {
  //   id: '5',
  //   value: 'Bulk Refund',
  //   iconId: IconIds.BULK_REFUND,
  //   navigateTo: Routes.DEFAULT + Routes.BULK_REFUND,
  // },
]

const getSideMenuItems = (
  userType: string,
  disableBulkRefund: boolean,
  notAllowedPermissions: () => void | any,
  permissionLoader: boolean,
  showHideSubMenu: any,
  isSuperMerchant: boolean,
  showPayouts: boolean,
): any[] => {
  let userPermissionNotAllowedArray: any = []

  if (!permissionLoader) {
    userPermissionNotAllowedArray =
      typeof notAllowedPermissions === 'function' ? notAllowedPermissions() : notAllowedPermissions
    if (userType === 'MID') {
      const sideMenudata = isSuperMerchant ? defaultSuperMerchantSideMenuData : defaultSideMenuData
      let sideMenuClone = JSON.parse(JSON.stringify(sideMenudata))

      userPermissionNotAllowedArray.forEach((element: any) => {
        sideMenuClone?.map((item: any, index: number) => {
          if (item?.value === element) {
            sideMenuClone.splice(index, 1)
          }
        })
      })
      let filteredItem = sideMenuClone.filter((item: any) => item.value !== 'Bulk Refund' || !disableBulkRefund)
      if (showHideSubMenu && !showHideSubMenu.show) {
        filteredItem = filteredItem.filter((item: any) => item.parentId === undefined)
      }
      //To remove payouts from side menu
      if (!showPayouts) {
        filteredItem = filteredItem.filter((item: any) => item.value !== 'Payouts')
      }
      if (filteredItem[filteredItem.length - 1].id === 'DIVIDER') {
        return filteredItem.slice(0, -1)
      } else {
        return filteredItem
      }
    }
  }
  return []
}

const getSelectedPosWithDelay = () => {
  return new Promise(function (resolve) {
    setTimeout(() => resolve(getSelectedPos()), 10)
  })
}

const { REACT_APP_ENDPOINT = '' } = window?._env_ ?? {}

const getSelectedPos = (): number => {
  let path = window.location.pathname.slice(1)

  if (path === '/') {
    return 1
  }
  if (REACT_APP_ENDPOINT && path.startsWith(REACT_APP_ENDPOINT.slice(1))) {
    path = path.slice(REACT_APP_ENDPOINT.length)
  }

  const pathPositions: any = {
    dashboard: 1,
    'initiate-refunds': 1,
    'dashboard/initiate-refunds': 1,
    transactions: 2,
    'transactions/initiate-refunds': 2,
    settlements: 3,
    'settlements-reporting': 3,
    'settlements-add-update': 3,
    'refund-reports': 4,
    'refunds/initiate-refunds': 4,
    'create-payment-link': 5,
    'payment-links': 5,
    subscriptions: 6,
    insights: 7,
    'bulk-refund': 8,
    vault: 9,
    settings: 10,
    UpiQRCode: 12,
    'add-new-user': 10,
    'edit-user-role': 10,
    'contact-us': 14, //put 8 to highlight
    campaigns: 11,
    'campaigns/createcampaign': 11,
    reports: 13,
    beneficiaryOnboarding: 15,
    'help-and-support': 16,
  }
  return path.length === 0 ? 1 : pathPositions[path] || -1
}

const Logo = (): React.ReactElement => {
  return (
    <Box {...styles.logo}>
      <Icon id={'JIO_ICON'} color={'WHITE'} size={32} />
      <Spacer size={5} direction="horizontal" />
      <Text type={'largeTitle'} {...styles.logoText}>
        {loginStrings.pay}
      </Text>
    </Box>
  )
}

const Navbar: FC<NavBarProps> = ({
  onPress,
  disableBulkRefund = false,
  userPermissionsNotAllowed = [],
  permissionLoader,
  isSuperMerchant = false,
  showPayouts,
}: NavBarProps) => {
  const [showHideSubMenu, setShowHideSubMenu] = useState({ show: false, parentId: '-1' })
  const [scrollInfo, setScrollInfo] = React.useState({ displayHeight: 0, virtualHeight: 0, contentOffset: 0 })
  const flatListRef = createRef(null)

  const getLogo = (): React.ReactElement => {
    return Logo()
  }

  const getSideMenuBottomData = (): ListData[] => {
    return sideMenuBottomData
  }
  const [position, setPosition] = useState(0)

  getSelectedPosWithDelay().then((res) => {
    setPosition(res as number)
  })

  const data = getSideMenuItems(
    mid,
    disableBulkRefund,
    userPermissionsNotAllowed,
    permissionLoader,
    showHideSubMenu,
    isSuperMerchant,
    showPayouts,
  )

  const screenH = useWindowDimensions()?.height
  console.log(screenH)

  const handleShowHideSubMenu = (showHideMenu: boolean, parentId: string) => {
    setShowHideSubMenu({ show: showHideMenu, parentId: parentId })
  }

  return (
    <Box f={1}>
      {/* <ModBox f={1} overflow={'auto'} show={!permissionLoader}>
        {getLogo()}
        {data.map((item: any) => {
          return (
            <ListItem
              type={ListTypes.SIDE_MENU}
              data={item}
              selected={Number(position) === +item.id}
              onPress={() => onPress(item)}
            />
          )
        })}
      </ModBox> */}
      <Box {...styles.menuFooterCOntainer} f={1} overflow={'auto'} show={!permissionLoader}>
        <List
          type={ListItemType.SIDE_MENU}
          data={data}
          header={getLogo}
          onPress={onPress}
          flatListRef={flatListRef}
          selectedPos={Number(position)}
          onLayout={({
            nativeEvent: {
              layout: { height },
            },
          }: any) => {
            setScrollInfo({ ...scrollInfo, displayHeight: height })
          }}
          onScroll={({
            nativeEvent: {
              contentOffset: { y },
            },
          }: any) => {
            setScrollInfo({ ...scrollInfo, contentOffset: y })
          }}
          onContentSizeChange={(_, virtualHeight) => {
            setScrollInfo({ ...scrollInfo, virtualHeight })
          }}
          showHideSubMenu={handleShowHideSubMenu}
        />
        <ModBox
          alignItems={'center'}
          show={scrollInfo.virtualHeight - scrollInfo.displayHeight > 50}
          marginTop={20}
          borderColor={'WHITE'}
          opacity={scrollInfo.virtualHeight === scrollInfo.displayHeight + scrollInfo.contentOffset ? 0.3 : 1}
          borderTopWidth={1}>
          <IconButton
            size={32}
            color="WHITE"
            id={'ARROW_DOWN'}
            testID={'expand-bottom-nav'}
            onPress={() => {
              flatListRef?.current?.scrollToOffset({ offset: scrollInfo.contentOffset + 30 })
            }}
          />
        </ModBox>
        {/* <Box {...styles.menuFooterCOntainer}>
          <List
            type={ListItemType.MENU_TITLE}
            data={getSideMenuBottomData()}
            onPress={onPress}
            selectedPos={Number(position)}
          />
        </Box> */}
      </Box>
      <ModBox f={1} justify={'center'} show={permissionLoader}>
        <LoaderNew color={'WHITE'} />
      </ModBox>
    </Box>
  )
}
export default Navbar
